import { render, staticRenderFns } from "./PhoneLinks.vue?vue&type=template&id=514405be&"
import script from "./PhoneLinks.vue?vue&type=script&lang=js&"
export * from "./PhoneLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports